"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const Introduction_class_1 = __importDefault(require("./Introduction.class"));
exports.default = (0, vue_1.defineComponent)({
    setup: () => {
        const component = new Introduction_class_1.default();
        return {
            startTest: component.startTest.bind(component)
        };
    }
});
